export enum ConditionKind {
  CUSTOMER_GROUP = "customer-group",
  REVENUE = "revenue"
}
